module.exports = __webpack_public_path__ + "static/media/bayofpigs.31d9b067.jpg";